import { render, staticRenderFns } from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=template&id=3ca6617c"
import script from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=style&index=0&id=3ca6617c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports